import * as React from 'react';
import { Button, Modal, Nav, NavItem, Tab } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import TemplateForm from './TemplateForm';
import { getSiteName } from '../../shared/Site';
import * as Site from '../../shared/Site';

class TemplateModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            activeTab: 0,
            tags: [],
            template: [],
            files: []
        };

        this.closeModal = this.closeModal.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onImageUploaded = this.onImageUploaded.bind(this);
        this.onIFrameUrlChange = this.onIFrameUrlChange.bind(this);
        this.onIsIframeChange = this.onIsIframeChange.bind(this);
    }

    componentDidMount() {
        let templates = assign([], this.props.template);
        let files = assign([], this.props.files);
        let tags = assign([], this.props.tags);
        if (this.props.site === getSiteName(Site.Zentuvo)) {
            let filteredTemplates = templates.filter(t => t.site === 1);
            this.setState({ template: filteredTemplates, files: files, tags: tags });
        } else {
            this.setState({ template: templates, files: files, tags: tags });
        }
    }

    onChange(e: any) {
        let templates = this.state.template;
        let template = templates[this.state.activeTab];
        template[e.target.name] = e.target.value;
        this.setState({ template: templates });
    }

    onEditorChange(content: string, index: number) {
        if (index !== this.state.activeTab) {
            return;
        }

        let templates = this.state.template;
        let template = templates[this.state.activeTab];
        template.content = content;
        this.setState({ template: templates });
    }

    handleTabChange(key: React.SyntheticEvent) {
        this.setState({ activeTab: key });
    }

    onImageUploaded(reference: string, filename: string) {
        let files = assign([], this.state.files);
        files.push({ reference: reference, filename: filename });
        this.setState({ files: files });
    }

    onIFrameUrlChange(e: any) {
        let templates = this.state.template;
        let template = templates[this.state.activeTab];
        template.iFrameUrl = e.target.value;
        this.setState({ template: templates });
    }

    onIsIframeChange(isIframe: boolean) {
        let templates = [...this.state.template];
        templates[this.state.activeTab].isIFrame = isIframe;
        this.setState({ template: templates });
    }

    renderTab(template: any, index: number) {
        if (this.state.activeTab === index) {
            return (
                <Tab.Pane key={'tab_' + index} eventKey={index}>
                    <TemplateForm
                        template={template}
                        files={this.state.files}
                        tags={this.state.tags}
                        index={index}
                        onChange={this.onChange}
                        onEditorChange={this.onEditorChange}
                        onImageUploaded={this.onImageUploaded}
                        onIFrameUrlChange={this.onIFrameUrlChange}
                        onIsIframeChange={this.onIsIframeChange}
                    />
                </Tab.Pane>
            );
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.closeModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{Translate('templates/modal/title/templates')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.site === getSiteName(Site.Zentuvo) ?
                    <Tab.Container
                        activeKey={this.state.activeTab}
                        onSelect={this.handleTabChange}
                        id="uncontrolled-tab"
                    >
                        <div>
                            <Nav>
                                {this.state.template.map((t: any, index: number) => {
                                    return (<NavItem key={'navItem_' + index} eventKey={index}>
                                            {(t.site
                                                ? t.site === 1
                                                    ? 'Zentuvo ' + Translate(t.languageTranslationKey)
                                                    : null : null)}
                                        </NavItem>
                                    )})}
                            </Nav>
                            <Tab.Content>
                                {this.state.template.map((t: any, index: number) =>
                                    this.renderTab({ ...t }, index)
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                    :
                    <Tab.Container
                        activeKey={this.state.activeTab}
                        onSelect={this.handleTabChange}
                        id="uncontrolled-tab"
                    >
                        <div>
                            <Nav>
                                {this.state.template.map((t: any, index: number) => (
                                    <NavItem key={'navItem_' + index} eventKey={index}>
                                        {(t.site
                                            ? t.site === 1
                                                ? 'SE360 '
                                                : 'Scandphotos '
                                            : '') + Translate(t.languageTranslationKey)}
                                    </NavItem>
                                ))}
                            </Nav>
                            <Tab.Content>
                                {this.state.template.map((t: any, index: number) =>
                                    this.renderTab({ ...t }, index)
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.closeModal}>
                        {Translate('templates/modal/footer/button-label/close')}
                    </Button>
                    <Button bsStyle="primary" onClick={this.onSave}>
                        {Translate('templates/modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    closeModal() {
        this.props.close();
    }

    onSave() {
        this.props.save(this.state.template);
    }
}

export default TemplateModal;
